/*eslint-disable*/
import React from "react";
import { Link } from "react-router-dom";
// components

import IndexDropdown from "components/Dropdowns/IndexDropdown.js";

export default function Navbar(props) {
  const [navbarOpen, setNavbarOpen] = React.useState(false);
  const handleReload = () => {
    // Redirect to the root URL and reload the whole page
    window.location.href = "/";
  };
  return (
    <>
      <nav
        className="navbar navbar-expand-lg bg-white navbar-light sticky-top py-lg-2 px-lg-5 mb-3  shadow"
        data-wow-delay="0.1s"
      >
        {/* <div className="container px-4 mx-auto flex flex-wrap items-center justify-between"> */}
        {/* Logo Section */}
        {/* <div className="flex items-center"> */}
        <Link to={"#"} className="navbar-brand ms-4" onClick={handleReload}>
          <img
            src={require("assets/img/essentials_small.png")}
            alt="Logo not found"
            style={{ width: "200px" }}
          />
        </Link>
        {/* </div>       */}
        {/* </div> */}
      </nav>
    </>
  );
}
